import { Operation } from 'module/api/filter/types';
import { unreachable } from 'module/helpers/unreachable';
import {
  SelectFilterOperationType,
  valueFromString,
} from 'module/types/filter-field/filter/select';

export const toType = (operation: Operation): SelectFilterOperationType => {
  switch (operation) {
    case Operation.IsEmpty:
      return SelectFilterOperationType.IsEmpty;
    case Operation.IsNotEmpty:
      return SelectFilterOperationType.IsNotEmpty;
    case Operation.Value:
      return SelectFilterOperationType.Is;
    case Operation.IsNot:
      return SelectFilterOperationType.IsNot;
    case Operation.OneOf:
      return SelectFilterOperationType.IsOneOf;
    case Operation.NoneOf:
      return SelectFilterOperationType.IsNoneOf;
    case Operation.GreaterThanEqual:
      return SelectFilterOperationType.IsAtLeast;
    case Operation.LessThanEqual:
      return SelectFilterOperationType.IsAtMost;
    case Operation.HasValue:
    case Operation.IsNull:
    case Operation.Contains:
    case Operation.GreaterThan:
    case Operation.LessThan:
    default:
      return unreachable(operation as never);
  }
};

export const fromApiValue = valueFromString((value) => {
  const result = Number(value);

  // NOTE:: for inferredProgress the value will be string and we need to return the string.
  return Number.isNaN(result) || Number.isNaN(Number(value))
    ? (value as unknown as number)
    : result;
}, ',');
